"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIntFromHex = getIntFromHex;
function getIntFromHex(str) {
    return parseInt(str.replace(/^#/, ""), 16);
}
